import React from 'react'
import {graphql, Link} from 'gatsby'
import {Helmet} from 'react-helmet'
import Layout from '../components/layout'
import Seo from '../components/seo'
import BlogList from '../components/blogList'
import * as blogStyles from './blog.module.scss'

export const query = graphql`
    query($name: String, $skip: Int!, $limit: Int!) {
        allContentfulBlogPost (
            filter: {category: {elemMatch: {name: {eq: $name}}}, subcategory: {elemMatch: {name: {nin: "Recipes"}}}}, 
            sort: {publishedDate: DESC},
            skip: $skip,
            limit: $limit)
            {
            edges {
                node {
                    blogTitle
                    subtitle
                    slug
                    category {
                        slug
                    }
                    publishedDate(formatString: "MMMM DD, YYYY")
                    thumbnailImage {
                        imgixImage {
                            gatsbyImageData (width: 1000, imgixParams: {q: 75, mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png"})
                          }
                        description
                    }
                    bodyExcerptRich {
                        raw
                    }
                }
            }
        }
        contentfulCategory (name: {eq: $name}) {
            name
            slug
            metaDescription
        }
    }
`

const CategoryPage = (props) =>{
    return (
        <div>
            <Seo 
                title={props.data.contentfulCategory.name} 
                description={props.data.contentfulCategory.metaDescription}
                path={`/${props.data.contentfulCategory.slug}`}
            />
            <Helmet>
           
             </Helmet>
            
            <Layout>
            
                <div className="ss-container">
                    <h1 className="heading">{props.data.contentfulCategory.name}</h1>
                    
                    <BlogList data={props.data.allContentfulBlogPost.edges} />
                    {props.pageContext.numberOfPages > 1 ? 
                    <div className={blogStyles.pagination}>
                        
                        <div className={blogStyles.pageNavBar}>
                        { props.pageContext.pageNumber !== 0 ?
                            <Link className={blogStyles.pageNav} to={props.pageContext.previousPagePath}>&larr; Previous</Link> 
                            : <div className={blogStyles.pageNav}></div>}
                            <div className={blogStyles.currentPage}>
                        Page {props.pageContext.pageNumber + 1} of {props.pageContext.numberOfPages}
                        </div>
                        { props.pageContext.pageNumber + 1 !== props.pageContext.numberOfPages ? 
                        <Link className={blogStyles.pageNav} id={blogStyles.next} to={props.pageContext.nextPagePath}>Next &rarr;</Link>
                            : 
                            <div className={blogStyles.pageNav} id={blogStyles.next}></div>
                            }
                        </div>
                    </div>
                    : <div></div>}
                </div>
            </Layout>
        </div>
    )
}

export default CategoryPage